var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemarks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23C17.8513 23 23 17.8513 23 11.5Z",
    fill: "url(#paint0_linear_852_14392)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6754 6.86719H6.33086C6.15484 6.86726 5.98149 6.91025 5.82582 6.99242C5.67015 7.0746 5.53687 7.19348 5.4375 7.33877L10.6093 11.0059C10.8706 11.1905 11.1827 11.2897 11.5026 11.2897C11.8226 11.2897 12.1347 11.1905 12.396 11.0059L17.5672 7.33877C17.468 7.1937 17.3349 7.07496 17.1796 6.9928C17.0242 6.91064 16.8512 6.86753 16.6754 6.86719Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8379 11.6404C12.4459 11.9179 11.9774 12.067 11.4971 12.067C11.0167 12.067 10.5482 11.9179 10.1562 11.6404L5.24219 8.15625V15.0465C5.24219 15.3337 5.35627 15.6091 5.55935 15.8122C5.76243 16.0153 6.03786 16.1294 6.32505 16.1294H16.6696C16.9568 16.1294 17.2323 16.0153 17.4353 15.8122C17.6384 15.6091 17.7525 15.3337 17.7525 15.0465V8.15625L12.8379 11.6404Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5Z",
    fill: "url(#paint1_linear_852_14392)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_14392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0742 10.2266C14.0742 9.98925 13.8818 9.79688 13.6445 9.79688H9.21875C8.98143 9.79688 8.78906 9.98925 8.78906 10.2266C8.78906 10.4639 8.98143 10.6562 9.21875 10.6562H13.6445C13.8818 10.6562 14.0742 10.4639 14.0742 10.2266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21875 11.5156C8.98143 11.5156 8.78906 11.708 8.78906 11.9453C8.78906 12.1826 8.98143 12.375 9.21875 12.375H11.9067C12.144 12.375 12.3364 12.1826 12.3364 11.9453C12.3364 11.708 12.144 11.5156 11.9067 11.5156H9.21875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2261 15.6406H8.78906C8.3152 15.6406 7.92969 15.2551 7.92969 14.7812V7.21875C7.92969 6.74489 8.3152 6.35938 8.78906 6.35938H14.0718C14.5457 6.35938 14.9312 6.74489 14.9312 7.21875V9.86133C14.9312 10.0986 15.1236 10.291 15.3609 10.291C15.5982 10.291 15.7906 10.0986 15.7906 9.86133V7.21875C15.7906 6.27103 15.0196 5.5 14.0718 5.5H8.78906C7.84134 5.5 7.07031 6.27103 7.07031 7.21875V14.7812C7.07031 15.729 7.84134 16.5 8.78906 16.5H10.2261C10.4634 16.5 10.6558 16.3076 10.6558 16.0703C10.6558 15.833 10.4634 15.6406 10.2261 15.6406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5482 11.7208C16.0456 11.2181 15.2278 11.2181 14.7256 11.7204L12.3665 14.0742C12.3164 14.1242 12.2795 14.1858 12.2589 14.2535L11.7451 15.9449C11.6996 16.0948 11.7393 16.2577 11.8487 16.3698C11.9307 16.4539 12.0421 16.4995 12.1563 16.4995C12.1945 16.4995 12.2331 16.4944 12.271 16.4839L14.0053 16.0035C14.0767 15.9837 14.1417 15.9458 14.1941 15.8935L16.5483 13.5438C17.0509 13.0412 17.0509 12.2234 16.5482 11.7208ZM13.667 15.2054L12.7945 15.4471L13.0498 14.6065L14.6416 13.0182L15.2494 13.626L13.667 15.2054ZM15.9409 12.9359L15.8576 13.0189L15.25 12.4113L15.3329 12.3285C15.5005 12.1609 15.7731 12.1609 15.9406 12.3285C16.1081 12.496 16.1081 12.7686 15.9409 12.9359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6445 8.07812H9.21875C8.98143 8.07812 8.78906 8.2705 8.78906 8.50781C8.78906 8.74513 8.98143 8.9375 9.21875 8.9375H13.6445C13.8818 8.9375 14.0742 8.74513 14.0742 8.50781C14.0742 8.2705 13.8818 8.07812 13.6445 8.07812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_14392",
    x1: 11.9907,
    y1: 0,
    x2: 11.9907,
    y2: 20.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998403,
    stopColor: "#F94327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_14392",
    x1: 11.9907,
    y1: 0,
    x2: 11.9907,
    y2: 20.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998403,
    stopColor: "#F94327"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_14392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(6.5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarks);
export default __webpack_public_path__ + "static/media/remarks.3f14195ef2b8bd5c4a2f83d226ad0619.svg";
export { ForwardRef as ReactComponent };